import { render, staticRenderFns } from "./ProjectDetailsSection.vue?vue&type=template&id=aa600304&scoped=true&"
import script from "./ProjectDetailsSection.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailsSection.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailsSection.vue?vue&type=style&index=0&id=aa600304&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa600304",
  null
  
)

export default component.exports